
import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import LanguageMenuItem from './language/LanguageMenuItem';
import { LanguageCode, languageInfo } from '@/utils/languageUtils';

const LanguageSwitcher = () => {
  const { currentLanguage, setLanguage } = useLanguage();
  
  const handleLanguageSelect = (code: LanguageCode) => {
    setLanguage(code);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-2 bg-[#2A2F42]/90 hover:bg-[#3A3F52] text-white rounded-md px-3 py-2 border border-purple-500/30 hover:border-purple-500/50 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500/40">
        <Globe size={16} className="text-purple-300" />
        <span className="text-xl font-emoji">{languageInfo[currentLanguage as LanguageCode].flag}</span>
      </DropdownMenuTrigger>
      
      <DropdownMenuContent 
        align="end" 
        className="bg-[#1A1F2C]/95 backdrop-blur-md border border-purple-500/30 shadow-lg shadow-purple-500/20 rounded-md min-w-[140px] p-1 animate-in fade-in-80 data-[side=bottom]:slide-in-from-top-2"
      >
        {Object.keys(languageInfo).map((code) => (
          <LanguageMenuItem
            key={code}
            code={code as LanguageCode}
            isActive={currentLanguage === code}
            onSelect={handleLanguageSelect}
          />
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
